/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close': {
    width: 17.031,
    height: 17.031,
    viewBox: '0 0 17.031 17.031',
    data: '<path pid="0" d="M17.037 1.378L15.654-.005 8.516 7.133 1.379-.005-.005 1.378l7.137 7.138L-.01 15.65l1.384 1.383 7.137-7.137 7.138 7.137 1.388-1.383L9.9 8.512z" fill-rule="evenodd"/>'
  }
})
